module.exports = __webpack_public_path__ + "static/media/view_report.09df5d78.svg";